// extracted by mini-css-extract-plugin
export var toggle = "Variants-module--toggle--c3ca2";
export var variants = "Variants-module--variants--23f95";